module.exports = __webpack_public_path__ + "assets/img/s3-tab-2-active-efc45122.png";